import{jsxs as t,jsx as a}from"react/jsx-runtime";import{twMerge as e}from"tailwind-merge";import{Box as s}from"../../Base/Layouts/Box/Box.js";import"../../Base/Layouts/FullBleed/FullBleed.js";import"react";import"../../DataDisplays/SystemIcon/SystemIcon.constants.js";import{CountBadge as r}from"../../DataDisplays/CountBadge/CountBadge.js";import{NewBadge as o}from"../../DataDisplays/NewBadge/NewBadge.js";
/**
 * 자식 요소의 우측 상단에 뱃지를 표시하는 래퍼 컴포넌트입니다.
 *
 * @param {Object} props
 * @param {ReactNode} props.children - 뱃지와 함께 표시될 자식 요소
 * @param {string} [props.text] - 뱃지에 표시될 텍스트 (variant가 'new'가 아닐 때 사용)
 * @param {string} [props.className] - 추가적인 스타일링을 위한 클래스명
 * @param {'primary' | 'secondary' | 'new'} [props.variant='primary'] - 뱃지의 스타일 변형 (primary, secondary, new)
 * @param {boolean} [props.showZero=false] - 텍스트가 '0'일 때도 뱃지를 표시할지 여부
 *
 * @example
 * // 숫자 뱃지 사용
 * <WithBadge text="5" variant="primary">
 *   <Button>알림</Button>
 * </WithBadge>
 *
 * // NEW 뱃지 사용
 * <WithBadge variant="new">
 *   <MenuItem>새로운 기능</MenuItem>
 * </WithBadge>
 */const i=({text:i,children:m,className:l,variant:n="primary",showZero:p=!1})=>/*#__PURE__*/t(s,{className:e("relative w-fit",l),"data-testid":"with-badge",children:[m,"new"===n?/*#__PURE__*/a(o,{className:"absolute right-0 top-0 -translate-y-1/2 translate-x-1/2 transform"}):/*#__PURE__*/a(r,{text:i,variant:n,showZero:p,className:"absolute right-px top-px -translate-y-1/2 translate-x-1/2 transform"})]});export{i as WithBadge};
